var _path, _path2, _path3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetricHyprFlow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8021_9752)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8021_9752",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8021_9752)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 0H4C1.79086 0 0 1.79086 0 4V20C0 22.2091 1.79086 24 4 24H20C22.2091 24 24 22.2091 24 20V4C24 1.79086 22.2091 0 20 0Z",
    fill: "url(#paint0_linear_8021_9752)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_8021_9752",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 4,
    width: 15,
    height: 15
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 4H5V19H20V4Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_8021_9752)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0683 6.55078H10.6592V9.95987H14.0683V6.55078Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.40909 13.5454H5V16.9545H8.40909V13.5454Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8632 13.5454H10.4541V16.9545H13.8632V13.5454Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3183 13.5454H15.9092V16.9545H19.3183V13.5454Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0465 12.1747C19.1529 12.2678 19.1985 12.4226 19.1868 12.6481L19.4729 12.663C19.4897 12.3441 19.4116 12.114 19.2351 11.9593C18.8103 11.5874 17.9193 11.7548 16.57 12.0077C15.4461 12.2187 14.0611 12.4734 12.4891 12.5049V9.84448H12.2027V12.5049C10.6306 12.4734 9.2458 12.2187 8.12193 12.0077C6.77308 11.7547 5.88163 11.5874 5.45688 11.9593C5.28017 12.114 5.20226 12.3443 5.21902 12.663L5.50514 12.6481C5.49326 12.4227 5.53908 12.2679 5.64548 12.1747C5.9654 11.8947 6.89366 12.0689 8.06908 12.2894C9.19926 12.5012 10.5901 12.7587 12.1773 12.7922V12.7988C12.2345 12.7988 12.2893 12.7959 12.3459 12.7955C12.4026 12.7961 12.4575 12.7988 12.5146 12.7988V12.7922C14.1019 12.7588 15.4928 12.5014 16.6229 12.2894C17.7981 12.0689 18.7265 11.8947 19.0465 12.1747Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8021_9752",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5A5A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8021_9752"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetricHyprFlow);
export default __webpack_public_path__ + "static/media/Metric-HyprFlow.3c36a3a0c7c6b170532bab047f570f3b.svg";
export { ForwardRef as ReactComponent };